<template>
  <div class="card mb-25 border-0 rounded-0 bg-white create-new-project-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
        </div>
      </div>
      <form @submit.prevent="submitTask">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Task Types
              </label>
              <select v-model="this.selectedTaskType" @change="onTaskTypeSetChange" class="form-select shadow-none fw-semibold rounded-0" :disabled="this.isEdit">
                  <option v-for="item in this.taskTypes" :key="item.id" :value="item.id" >
                     {{ item.taskName }}
                  </option>
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Todo Sets
              </label>
              <select v-model="this.selectedTodoSet" @change="onTodoSetChange" class="form-select shadow-none fw-semibold rounded-0" :disabled="this.isEdit">
                  <option v-for="item in this.todoSets" :key="item.id" :value="item">
                     {{ item.title }}
                  </option>
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Todo List
              </label>
              <select v-model="task.todoListId" class="form-select shadow-none fw-semibold rounded-0" :disabled="this.isEdit">
                  <option v-for="item in this.todoLists" :key="item.id" :value="item.id">
                     {{ item.title }}
                  </option>
              </select>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Title
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="Describe this task"
                v-model="task.content"
                :disabled="!task.todoListId"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Assigned to
              </label>
              <multiselect 
                  v-model="assignees" 
                  :options="peopleOnProject" 
                  :multiple="true" 
                  track-by="id" 
                  label="name" 
                  placeholder="Type names to assign"
                  :disabled="!task.todoListId"
                  class="project-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
                  >
              </multiselect>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                When done, notify
              </label>
              <multiselect 
                  v-model="subscribers" 
                  :options="completionSubscribers" 
                  :multiple="true" 
                  track-by="id" 
                  label="name" 
                  placeholder="Type names to notify"
                  :disabled="assignees.length <= 0"
                  class="project-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
                  >
              </multiselect>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Due on
              </label>
              <div class="input-group">
                  <span class="input-group-text rounded-0 fs-14 text-muted">
                  <i class="flaticon-calendar lh-1 position-relative top-1"></i>
                  </span>
                  <input
                  type="date"
                  class="form-control"
                  v-model="task.dueOn"
                  :disabled="!task.todoListId"
                  />
              </div>
            </div>
          </div>
          <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                      Notes
                  </label>
                  <div class="mb-0">
                      <QuillEditor
                      ref="editor"
                      theme="snow"
                      placeholder="Add extra details or attach a file"
                      toolbar="full"
                      v-model:content="task.description"
                      :disabled="!task.todoListId"
                      />
                  </div>
              </div>
          </div>
          <template v-for="item in task.customFields" :key="item.id" >
            <CustomField :customField="item" />
          </template>
          <div class="col-md-12">
              <button
                  v-if="this.isEdit" class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                  type="submit"
                  >
                  Edit Task
              </button>
              <button v-else
                  class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                  type="submit"
                  >
                  Add Task
              </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { GetAllBasecampProjectTodoLists, GetPeopleOnProject, CreateTask, GetProjectsById, GetAllTaskTypes, GetAllTaskCustomFieldsByTaskTypeId, GetBasecampTaskById, UpdateTask } from '@/core/services/entities/task.service'
import { useToast } from 'vue-toastification'
import { useRouter } from "vue-router";
import QuillDeltaToHtml from 'quill-delta-to-html';
import Quill from 'quill';
import CustomField from "../../components/Task/CustomField.vue";
import { ref} from 'vue';

export default{
  name: "CreateNewTask",
  async mounted() {
    this.isLoading = true
    const selectedProject = this.$route.params.projectId;
    this.projectId = this.$route.params.projectId;
    this.isEdit = this.$route.params.isEdit;
    
    await this.fetchPeopleOnProject(selectedProject)
    await this.GetProjectsById(selectedProject)
    await this.GetAllTaskTypes()
    if (this.isEdit) {
      this.taskId = this.$route.params.taskId;
      this.fetchTodo(this.projectId, this.taskId)
    } else {

      const selectedTodoSetsData = sessionStorage.getItem('selectedTodoSets');
      this.todoSetsDefault = selectedTodoSetsData ? JSON.parse(selectedTodoSetsData) : [];

      const selectedTodoListsData = sessionStorage.getItem('selectedTodoLists');
      this.todoListsDefault = selectedTodoListsData ? JSON.parse(selectedTodoListsData) : [];
      
      const todoListsData = sessionStorage.getItem('generatedTodoLists');
      this.todoLists = todoListsData ? JSON.parse(todoListsData) : [];

      if (this.todoSetsDefault.length >= 1) {
        this.selectedTodoSet = this.todoSetsDefault[0];
      }

      if (this.todoListsDefault.length >= 1) {
        this.task.todoListId = this.todoListsDefault[0].id;
      }
    }    
    this.isLoading = false
  },
  components: {
      Multiselect,
      CustomField
  },
  data(){
      return {
      projectId : null,
      taskId : null,
      isEdit : false,
      isLoading: false, 
      peopleOnProject: [],
      completionSubscribers: [],
      selectedTodoSet: {},
      selectedTaskType: {},
      assignees: [],
      subscribers:[],
      task: {
          taskId: '',
          projectId: this.$route.params.projectId,
          todoListId: this.$route.params.todoListId,
          content: '',
          assigneesIds: [], 
          subscribersIds: [], 
          dueOn: '',
          description: '',
          customFields: []
      },
    todoLists:[],
    todoSets:[],
    todoListsDefault:[],
    todoSetsDefault:[],
    projects: [],
    selectedProject: 0,
    taskTypes: []
    };
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
      const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day

      return `${year}-${month}-${day}`;
    },
    async fetchPeopleOnProject(projectId) {
      this.isLoading = true;
      const response = await GetPeopleOnProject(projectId);
      
      if (response && response.basecampPeopleProject) {
          this.peopleOnProject = response.basecampPeopleProject;
          this.completionSubscribers = response.basecampPeopleProject;
      } else {
          this.peopleOnProject = [];
          this.completionSubscribers = [];
      }
      this.isLoading = false;
    },
    async submitTask() {
      var cfg = {};
      const converter = new QuillDeltaToHtml(this.task.description.ops,cfg);
      const html = converter.convert();
      this.task.description=html;
      this.task.assigneesIds = this.assignees.map(assignee => assignee.id);
      this.task.subscribersIds = this.subscribers.map(subscriber => subscriber.id);
      this.task.taskId = this.taskId;
      this.isLoading = true;
      
      if(this.isEdit){
        await this.updateTask();
      } else {
        await this.createTask();
      }
      
      this.isLoading = false;
    },
    async createTask() {
      const toast = useToast();
      const router = useRouter();
      try{
          const response = await CreateTask(this.task);
          if (response.status === 200) {
            if(response.data.status)
            {
              toast.success('Task created successfully!', {
                timeout: 2000
              })
              this.$router.back();
            }
            else
            {
                toast.error(response.data.message, {
                timeout: 2000
               });
            }
          }
      }catch(error){
        console.log(error);
        toast.error('Failed to create task.', {
          timeout: 2000
        });
      }
    },
    async updateTask() {
      const toast = useToast();
      const router = useRouter();
      try{
          const response = await UpdateTask(this.task);
          if (response.status === 200) {
            if(response.data.status)
            {
              toast.success('Task Updated successfully!', {
                timeout: 2000
              })
              this.$router.back();
            }
            else
            {
                toast.error(response.data.message, {
                timeout: 2000
               });
            }
          }
      }catch(error){
        console.log(error);
        toast.error('Failed to create task.', {
          timeout: 2000
        });
      }
    },
    async fetchTodoSets(projectId) {
      this.isLoading = true;
      var project = this.projects.find(p => p.id === projectId);
      this.todoSets = project.dock.filter(d => d.name === 'todoset');
      this.isLoading = false;
    },
    async fetchTodoLists(projectId, todosetId) {
      this.isLoading = true;
      const response = await GetAllBasecampProjectTodoLists(projectId, todosetId);
      this.todoLists = response.basecampProjectTaskList;
      this.isLoading = false;
    },
    async fetchTodo(projectId, taskId) {
      this.isLoading = true;
      const response = await GetBasecampTaskById(projectId, taskId);
      this.todoLists = [ response.basecampTask.parent];
      this.task.todoListId  = response.basecampTask.parent.id;
      this.task.id = response.basecampTask.id;
      this.task.content = response.basecampTask.title;
      this.assignees = response.basecampTask.assignees;
      this.subscribers = response.basecampTask.completion_subscribers;
      this.task.dueOn = this.formatDate(response.basecampTask.due_on);
      const quill = new Quill(document.createElement('div'));
      this.task.description = quill.clipboard.convert(response.basecampTask.description);
      this.todoSets = [ response.basecampTask.taskSet ];
      this.selectedTodoSet = this.todoSets[0];
      if(response.basecampTask.taskType != null){
        this.selectedTaskType = response.basecampTask.taskType.id;
      }
      if(response.basecampTask.customFieldView != null){
        this.task.customFields = response.basecampTask.customFieldView.map(item => {
          return { id: item.id, basecampId: item.basecampId, customFieldId: item.customFieldId, customFieldName: item.customFieldName, customFieldValue: item.customFieldValue } })
      }
      console.log(response.basecampTask.customFieldView);
      console.log(this.task);
      this.isLoading = false;
    },
    async GetProjectsById(projectId) {
      try {
        const response = await GetProjectsById(projectId)
        this.projects.push(response.basecampProject)
        this.selectedProject = response.basecampProject.id
        this.fetchTodoSets(response.basecampProject.id)
      } catch (error) {
        console.log(this.isConnected)
        if(this.isConnected){
          const toast = useToast();
          toast.error('Error fetching dropdown To-Do Set');
        }
      }
    },
    async GetAllTaskTypes() {
      this.isLoading = true;
      const response = await GetAllTaskTypes();
      this.taskTypes = response.taskTypes;
      this.isLoading = false;
    },
    onTodoSetChange() {
      if(this.selectedTodoSet !=null){
        const todoSetArray = [this.selectedTodoSet];
        this.fetchTodoLists(this.selectedProject, todoSetArray );
      }
      this.selectedTodoLists = [];
      this.todoLists = [];
    },
    async onTaskTypeSetChange() {
      const response = await GetAllTaskCustomFieldsByTaskTypeId(this.selectedTaskType);
      if(response && response.taskCustomFields)
      {
         this.task.customFields = response.taskCustomFields.map(item => {
          return { customFieldId: item.id, customFieldName: item.customFieldName, customFieldValue: '' } })
      }
    }
  }
  
};
</script>
<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading {
  cursor: wait;
}
</style>